<template>
  <div>
    <data-table ref="dataTable" :option="option" class="tablebe">
      <span slot="ifIsGroup" slot-scope="test">
        <a-badge v-if="test" status="success" text="是" />
        <a-badge v-else status="error" text="否" />
      </span>
      <template slot="rowAction" slot-scope="text, record">
        <a-button
          type="link"
          size="small"
          @click="edit(record.Id, false)"
          v-if="!record.IsGroup"
          >编辑</a-button
        >
        <a-button
          type="link"
          size="small"
          @click="checkInfo(record.Id, true)"
          v-if="record.IsGroup"
          >编辑</a-button
        >
        <a-divider v-if="!record.IsGroup" type="vertical" />
        <a-popconfirm
          placement="bottomRight"
          okText="确认"
          cancelText="取消"
          @confirm="del(record.Id)"
          v-if="!record.IsGroup"
        >
          <template slot="title">
            <p>您确认删除吗？</p>
          </template>
          <a-button type="link" size="small">
            删除
          </a-button>
        </a-popconfirm>
      </template>
      <template #headAction>
        <a-button type="primary" style="margin-left:10px" @click="fileDown"
          >下载模板</a-button
        >
        <upLoadImage
          style="margin-left:10px"
          v-model="backUrl"
          :imageUrl="false"
          listType="text"
          text="导入"
          mode="file"
          @update="fileImport"
        />
      </template>
    </data-table>
    <a-modal
      title="提示"
      :visible="visible"
      :footer="null"
      @cancel="visible = false"
    >
      <p class="tip-info">
        客户信息填写有误，可以点击该链接<span class="file" @click="editFile">
          {{ docUrl }}</span
        >下载文档，根据文档提示修改后重新导入！
      </p>
    </a-modal>
  </div>
</template>

<script>
import { DataTable } from "@/components/dataTable";
import { cache } from "@/utils/common";
import moment from "moment";
import cloneDeep from "lodash/cloneDeep";
import upLoadImage from "@/components/tools/upLoadImage";
import { exportsDownLoad } from "@/utils/common";
export default {
  name: "CustomerManage",
  components: {
    DataTable,
    upLoadImage
  },
  data() {
    return {
      type: "0",
      endtime: "1991-12-25",
      AccountDate: "",
      CustomerTypeData: [],
      isGroup: false,
      option: {},
      Salesman: "",
      SalesmanData: [],
      backUrl: "",
      visible: false,
      docUrl: "",
      user: null
    };
  },
  created() {
    this.user = cache.get("user");
    this.AccountDate = cache.get("user").AccountDate;
    const _this = this;
    const content = [
      {
        label: "类别",
        name: "CustomerTypeId",
        type: "select",
        api: "Common_GetSelect",
        param: {
          Types: "CustomerType"
        },
        dataField: "Data.CustomerType",
        option: {
          rules: [{ required: true, message: "请选择类别!" }]
        },
        load: data => {
          _this.CustomerTypeData = data;
        }
      },
      {
        label: "名称",
        name: "Name",
        placeholder: "请输入",
        option: {
          rules: [{ required: true, message: "请输入用户名称!" }]
        }
      },
      {
        label: "编号",
        name: "Code",
        placeholder: "请输入",
        option: {
          validateFirst: true,
          rules: [
            { required: true, message: "请输入编号!" },
            {
              validator: (rule, value, callback) => {
                if (value) {
                  if (/[\u4E00-\u9FA5]/g.test(value)) {
                    callback(new Error("编码要求为数字格式!"));
                  } else {
                    callback();
                  }
                } else {
                  callback();
                }
              }
            }
          ]
        }
      },
      {
        label: "销售员",
        name: "SalesmanId",
        placeholder: "请选择",
        type: "select",
        api: "Common_GetSelect",
        param: {
          Types: "salesman"
        },
        dataField: "Data.salesman",
        option: {
          rules: [{ required: true, message: "请选择销售员!" }]
        },
        load: data => {
          _this.SalesmanData = data;
          if (data && data.length) {
            this.$nextTick(() => {
              const form = _this.$refs.dataTable.getForm().form;
              if (_this.type == "0") {
                if (this.user.OperatorId) {
                  form.setFieldsValue({
                    SalesmanId: this.user.OperatorId
                  });
                  this.Salesman = this.user.OperatorName;
                } else {
                  form.setFieldsValue({
                    SalesmanId: data[0].Id
                  });
                  this.Salesman = data[0].Text;
                }
              }
            });
          }
        },
        onChange: this.onChange
      },
      {
        label: "合同号",
        placeholder: "请输入",
        name: "ContractNo"
      },
      {
        label: "简称",
        placeholder: "请输入",
        name: "ShortName"
      },
      {
        label: "联系人",
        placeholder: "请输入",
        name: "Contacts",
        option: {
          validateFirst: true,
          rules: [
            {
              validator: (rule, value, callback) => {
                if (value) {
                  if (!/^[\u4E00-\u9FA5A-Za-z0-9_]+$/g.test(value)) {
                    callback(new Error("联系人不允许输入特殊字符!"));
                  } else {
                    callback();
                  }
                } else {
                  callback();
                }
              }
            }
          ]
        }
      },
      {
        label: "联系人电话",
        placeholder: "请输入",
        name: "ContactsInfo"
      },
      {
        label: "挂账标志",
        name: "OfferCreditSign",
        placeholder: "请选择",
        type: "select",
        api: "Common_GetSelect",
        param: {
          Types: "OfferCreditSign"
        },
        dataField: "Data.OfferCreditSign",
        option: {
          rules: [{ required: true, message: "请选择挂账标志!" }]
        }
      },
      {
        label: "总限额",
        placeholder: "请输入",
        name: "TotalLimit",
        type: "number",
        props: {
          precision: 2
        }
      },
      {
        label: "单次限额",
        placeholder: "请输入",
        name: "SingleTimeLimit",
        type: "number",
        props: {
          precision: 2
        }
      },
      {
        label: "价类",
        name: "PriceCodeId",
        placeholder: "请选择",
        type: "select",
        api: "Common_GetSelect",
        param: {
          Types: "pricecode"
        },
        dataField: "Data.pricecode",
        option: {
          rules: [{ required: true, message: "请选择价类!" }]
        }
      },
      {
        label: "有效期",
        type: "date-range-picker",
        width: "300px",
        name: "CheckInTime",
        min: moment(this.AccountDate, "YYYY-MM-DD")
      }
    ];
    const editContent = cloneDeep(content);
    editContent[editContent.length - 1].props = {};
    this.option = {
      headSearch: {
        colnum: 3,
        content: [
          {
            label: "挂账标志",
            type: "select",
            name: "OfferCreditSign",
            api: "Common_GetSelect",
            param: {
              Types: "OfferCreditSign"
            },
            dataField: "Data.OfferCreditSign"
          },
          {
            label: "类别",
            type: "select",
            name: "CustomerTypeId",
            api: "Common_GetSelect",
            param: {
              Types: "customertypecontainsgroup"
            },
            dataField: "Data.customertypecontainsgroup"
          },
          {
            label: "名称",
            width: "200px",
            name: "Name"
          }
        ]
      },
      form: {
        title: "客户",
        width: 980,
        content: content,
        add: {
          submitApi: "Customer_Add",
          onOpenBefore: () => {
            this.type = "0";
          },
          onOpenAfter: (res = {}) => {
            // 销售员默认为当前登录的用户
            if (this.SalesmanData && this.SalesmanData.length) {
              if (this.user.OperatorId) {
                res.SalesmanId = this.user.OperatorId;
                this.Salesman = this.user.OperatorName;
              } else {
                res.SalesmanId = this.SalesmanData[0].Id;
                this.Salesman = this.SalesmanData[0].Text;
              }
            }

            return res;
          },
          onSubmitBefore: values => {
            // 有效期为空的处理
            values = {
              ...values,
              StartTime:
                values.CheckInTime.length && values.CheckInTime[0]
                  ? moment(values.CheckInTime[0]).format("YYYY-MM-DD")
                  : "",
              EndTime:
                values.CheckInTime.length > 1
                  ? moment(values.CheckInTime[1]).format("YYYY-MM-DD")
                  : ""
            };
            values.Salesman = this.Salesman;
            return values;
          }
        },
        edit: {
          infoApi: "Customer_Get",
          submitApi: "Customer_Edit",
          content: editContent,
          onOpenBefore: () => {
            this.type = "1";
          },
          onOpenAfter: res => {
            const data = res.Data;
            const CheckInTime = [];
            if (data.StartTime) {
              CheckInTime.push(moment(data.StartTime, "YYYY-MM-DD"));
            }
            if (data.EndTime) {
              CheckInTime.push(moment(data.EndTime, "YYYY-MM-DD"));
            }
            const json = {
              ...data,
              OfferCreditSign: data.OfferCreditSign + ""
            };
            if (CheckInTime.length) {
              json.CheckInTime = CheckInTime;
            }
            this.CustomerTypeId = json.CustomerTypeName;
            this.Salesman = json.Salesman;
            return json;
          },
          onSubmitBefore: values => {
            if (this.isGroup) {
              this.editGroup(values.Id, values.PriceCodeId);
              this.$refs.dataTable.handleCancel();
              return false;
            } else {
              values = {
                ...values,
                StartTime:
                  values.CheckInTime.length && values.CheckInTime[0]
                    ? moment(values.CheckInTime[0]).format("YYYY-MM-DD")
                    : "",
                EndTime:
                  values.CheckInTime.length > 1
                    ? moment(values.CheckInTime[1]).format("YYYY-MM-DD")
                    : ""
              };
              values.Salesman = this.Salesman;
              return values;
            }
          }
        },
        del: {
          submitApi: "Customer_Delete"
        }
      },
      grid: {
        api: "Customer_List",
        columns: [
          {
            title: "序号",
            width: "4%",
            type: "indexcolumn"
          },
          {
            title: "类别",
            width: "6%",
            dataIndex: "CustomerTypeName"
          },
          {
            title: "编号",
            width: "6%",
            dataIndex: "Code"
          },
          {
            title: "名称",
            width: "9%",
            dataIndex: "Name"
          },
          {
            title: "简称",
            width: "6%",
            dataIndex: "ShortName"
          },
          {
            title: "集团客户",
            width: "6%",
            dataIndex: "IsGroup",
            scopedSlots: { customRender: "ifIsGroup" }
          },
          {
            title: "挂账标志",
            width: "6%",
            dataIndex: "OfferCreditSign",
            customRender: text => {
              if (text == "1") {
                return "挂账";
              } else if (text == "2") {
                return "禁用";
              } else {
                return "协议";
              }
            }
          },
          {
            title: "业务员",
            width: "6%",
            dataIndex: "Salesman"
          },
          {
            title: "联系人",
            dataIndex: "Contacts"
          },
          {
            title: "联系人电话",
            width: "8%",
            dataIndex: "ContactsInfo"
          },
          {
            title: "总限额",
            align: "right",
            width: "7%",
            dataIndex: "TotalLimit"
          },
          {
            title: "单次限额",
            align: "right",
            width: "8%",
            dataIndex: "SingleTimeLimit"
          },
          {
            title: "余额",
            align: "right",
            width: "5%",
            dataIndex: "Rest"
          },
          {
            title: "有效日期",
            width: "7%",
            dataIndex: "EndTime"
          },
          {
            title: "操作",
            dataIndex: "Id",
            width: "150px",
            key: "action",
            scopedSlots: { customRender: "rowAction" }
          }
        ]
      }
    };
  },
  methods: {
    edit(id, flag) {
      this.isGroup = false;
      this.setFieldsStatus(flag);
      this.$refs.dataTable.edit(id);
    },
    checkInfo(id, flag) {
      this.isGroup = true;
      this.setFieldsStatus(flag);
      this.$refs.dataTable.edit(id);
    },
    editGroup(Id, PriceCodeId) {
      this.$post("Customer_EditGroupCustomer", {
        Id: Id,
        PriceCodeId: PriceCodeId
      }).then(() => {
        this.$message.success("操作成功！");
      });
    },
    del(id) {
      this.$refs.dataTable.del({ Id: id });
    },
    onChange(value, data) {
      this.Salesman = data.Text;
    },
    setFieldsStatus(flag) {
      const fields = [
        "CustomerTypeId",
        "CustomerTypeName",
        "Name",
        "Code",
        "Salesman",
        "SalesmanId",
        "ContractNo",
        "ShortName",
        "Contacts",
        "ContactsInfo",
        "OfferCreditSign",
        "TotalLimit",
        "SingleTimeLimit",
        "CheckInTime"
      ];
      const newContent = this.$refs.dataTable.formOption.edit.content.map(
        item => {
          if (fields.indexOf(item.name) > -1) {
            if (item.props && typeof item.props === "object") {
              item.props.disabled = flag;
            } else {
              item.props = {
                disabled: flag
              };
            }
            if (item.option && item.option.rules && item.option.rules.length) {
              if (item.option.rules[0].required != undefined) {
                item.option.rules[0].required = !flag;
              }
            }
          }
          if (flag && item.name == "CustomerTypeId") {
            item.type = "input";
            item.name = "CustomerTypeName";
          } else if (
            !flag &&
            (item.name == "CustomerTypeName" || item.name == "CustomerTypeId")
          ) {
            item.type = "select";
            item.name = "CustomerTypeId";
            this.$nextTick(() => {
              const form = this.$refs.dataTable.getForm();
              form &&
                form.setFieldData("CustomerTypeId", this.CustomerTypeData);
            });
          }
          if (flag && item.name == "SalesmanId") {
            item.type = "input";
            item.name = "Salesman";
          } else if (
            !flag &&
            (item.name == "Salesman" || item.name == "SalesmanId")
          ) {
            item.type = "select";
            item.name = "SalesmanId";
          }
          return item;
        }
      );
      this.$refs.dataTable.formOption.edit.content = newContent;
    },
    //下载模板
    fileDown() {
      let url = this.$config.serverUrl + "" + "/api/Customer/FileDown";
      exportsDownLoad(url);
    },
    //导入
    fileImport() {
      const _this = this;
      this.$confirm({
        title: "确定导入吗?",
        okText: "确定",
        cancelText: "取消",
        onOk() {
          _this
            .$post(
              "Customer_FileImport",
              { Path: _this.backUrl },
              { alertError: false }
            )
            .then(res => {
              // this.$message.success("上传成功！");
              _this.$info({
                title: "提示",
                content: res.Data.Infos,
                onOk() {
                  _this.$refs.dataTable.headSearch();
                }
              });
            })
            .catch(err => {
              if (err.data.Code == "-1") {
                _this.visible = true;
                _this.docUrl = err.data.Message;
              } else {
                const h = _this.$createElement;
                const arr = err.data.Message.split("\r\n").map(el => {
                  return h("p", el);
                });
                _this.$error({
                  title: "提示",
                  content: h("div", [arr])
                });
              }
            });
        },
        onCancel() {}
      });
    },
    editFile() {
      let url = this.$config.serverUrl + "/" + this.docUrl;
      exportsDownLoad(url);
    }
  }
};
</script>

<style lang="less" scoped>
.tablebe {
  /deep/ .head {
    /deep/ .head-search-box {
      /deep/ .ant-form-item-label {
        width: 80px;
      }
    }
  }
  /deep/ .body {
    /deep/ .ant-table-align-right {
      div {
        text-align: center;
      }
    }
  }
}
.tip-info {
  padding: 30px 20px 50px;
  font-size: 16px;
}
.file {
  color: #1890ff;
  text-decoration: underline;
  cursor: pointer;
}
</style>
